import { render } from "./AdminPrices.vue?vue&type=template&id=3e2c13aa&scoped=true"
import script from "./AdminPrices.vue?vue&type=script&lang=js"
export * from "./AdminPrices.vue?vue&type=script&lang=js"

import "./AdminPrices.vue?vue&type=style&index=0&id=3e2c13aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e2c13aa"]])

export default __exports__